// extracted by mini-css-extract-plugin
export default {"btn":"RedBtnHovWithIcon_btn__bQsn7","txt":"RedBtnHovWithIcon_txt__z8eM-","iconBox":"RedBtnHovWithIcon_iconBox__f7xBK","icon":"RedBtnHovWithIcon_icon__dOiDO"};